<template>
  <div class="container">
    <BaseFrame
      :breadcrumb="[
        {
          name: 'saleRefundList',
          title: '销售退货列表'
        },
        {
          name: 'saleRefundEdit',
          title: '销售退货单'
        }
      ]"
      :btns="[
        {
          name: 'cancel',
          text: '取消',
        },
        {
          name: 'submit',
          text: '提交',
          type: 'primary'
        }
      ]"
      @btn-click="onBtnClick"
    >
      <div slot="content">
        <lk-card title="退货单信息" class="other-card">
          <lk-form :label-width='134' label-position="right">
            <lk-row :gutter='16'>
              <!-- <lk-col span="7">
                <lk-form-item label="退款方式:" prop="proceedsTypeId">
                  <lk-select v-model="saleRefund.proceedsTypeId" label-in-value @on-change="handleProceedsTypeChange">
                    <lk-option v-for="item in proceedsTypeList" :value="item.proceedsTypeId" :key="item.proceedsTypeId">{{ item.proceedsTypeName }}</lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col> -->
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span="7">
                <lk-form-item label="退回商品:">
                  <lk-button
                    type="primary"
                    @click="showAddRejectGoods"
                    :disabled="this.$route.name == 'saleRefundEdit'"
                  >
                    选择商品
                  </lk-button>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span="23">
                <lk-form-item>
                  <lk-Table :data="tableData" :columns="rejectColumn" class="rejectTable" border/>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item label="退货金额合计:">
                  <span>{{sumMoney}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" >
                <lk-form-item label="退款合计:">
                  <span>{{refundTotal}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span="10">
                <lk-form-item label="退款信息:" >
                  <div v-for="(refundItem, index) in refundList" :key="index">
                    <div class="refundMethod">
                      <lk-select placeholder='请选择退款方式' :clearable="refundData.length > 0" class="refundInput" v-model="refundItem.proceedsTypeId" label-in-value @on-change="handleProceedsTypeChange(refundItem, index)">
                      <lk-option v-for="item in proceedsTypeList" :value="item.proceedsTypeId" :key="item.proceedsTypeName">{{ item.proceedsTypeName }}
                        </lk-option>
                      </lk-select>
                      &nbsp;
                      <lk-input-number style="width:calc(50% - 25px)" v-model.trim="refundItem.amount" :max="999999999.99" :min="0" :active-change="false" placeholder='请输入退款金额' clearable @on-change="priceChange" :precision="2" ></lk-input-number>
                      <lk-button v-if="index!=0" type="text-primary" @click="deleteRefund(index)">删除</lk-button>
                      <div class="emptySpan" v-else></div>
                    </div>
                  </div>
                  <span v-if="refundList.length < 5" class="addButton" @click="addNew">+添加退款方式</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16' v-if="refundData != undefined && refundData.length>0">
              <lk-col span="23">
                <lk-form-item label="预收核销退回:">
                  <lk-table :data="refundData" :columns="refundColum" class="rejectTable" border/>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span="7">
                <lk-form-item label="验收记录:">
                  <lk-input type="textarea" placeholder="请输入" v-model="saleRefund.inspectRecord"/>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span="7">
                <lk-form-item label="验收人员:">
                  <lk-input placeholder="请输入" v-model="saleRefund.refundInspector"/>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </BaseFrame>
    <ReturnGoodsModal :show="ModalShow" @cancel="onAddRejectGoodsModalCancel" @ok="onAddRejectGoodsOk" :selectedTable="selected"/>
  </div>
</template>

<script>
import _ from 'lodash';
import BaseFrame from '../../components/frame/NewBaseFrame.vue';
import utils from '../../libs/utils';
// import AnTable from '../../components/table';
import EditReturnExpand from './EditReturnExpand.vue';
import ReturnGoodsModal from './ReturnGoodsModal';
import afterSale from '../../services/afterSale';
import system from '../../services/system';

export default {
  name: 'saleRefundEdit',
  components: {
    BaseFrame,
    // AnTable,
    ReturnGoodsModal,
  },
  data() {
    return {
      refundList: [],
      refundTotal: 0,
      sumMoney: 0,
      saleRefundId: '',
      inventoryArr: [],
      saleRefund: {
        inspectRecord: '',
        refundInspector: '',
      },
      proceedsTypeList: [],
      ModalShow: false,
      addRejectValidate: {
        goodsId: [
          {
            required: true, message: '请选择商品', trigger: 'blur', type: 'number',
          },
        ],
        rejectNum: [
          {
            required: true, message: '请输入拒收数量', trigger: 'blur',
          },
        ],
        rejectReason: [
          {
            required: true, message: '请输入拒收原因', trigger: 'blur',
          },
        ],
      },
      refundData: [],
      refundColum: [
        {
          title: '序号',
          minWidth: 80,
          render: (h, { index }) => h('span', index + 1),
        },
        {
          title: '收款单号',
          minWidth: 116,
          key: 'depositCode',
        },
        {
          title: '付款人',
          minWidth: 116,
          key: 'paymentUserName',
        },
        {
          title: '联系方式',
          minWidth: 116,
          key: 'paymentUserPhone',
        },
        {
          title: '核销金额',
          minWidth: 116,
          key: 'verificationAmount',
        },
        {
          title: '已退款金额',
          minWidth: 116,
          key: 'refundedAmount',
          render: (h, params) => h('span', params.row.refundedAmount ? params.row.refundedAmount : '0'),
        },
        {
          title: '退款中金额',
          minWidth: 116,
          key: 'refundingAmount',
          render: (h, params) => h('span', params.row.refundingAmount ? params.row.refundingAmount : '0'),
        },
        {
          title: '可退款金额',
          minWidth: 116,
          key: 'ableToRefundAmount',
        },
        {
          title: '退款金额',
          minWidth: 130,
          key: 'refundAmount',
          render: (h, { row, index }) => h('lk-input-number', {
            on: {
              'on-change': (e) => {
                this.refundData[index].refundAmount = e;
                if (e * 1 > this.refundData[index].verificationAmount * 1) {
                  this.$Message.error('预收退款金额不能大于可退款金额');
                  return;
                }
                this.priceChange();
              },
            },
            props: {
              value: row.refundAmount,
              placeholder: '退款金额',
              min: 0,
              precision: 2,
              max: row.ableToRefundAmount * 1,
              'active-change': false,
            },
          }),
        },
      ],
      addRejectGoodsModalShow: false,
      rejectColumn: [
        {
          type: 'expand',
          width: 46,
          render: (h, { row }) => h(EditReturnExpand,
            {
              props: {
                row,
              },
            }),
        },
        {
          title: '序号',
          minWidth: 80,
          render: (h, { index }) => h('span', index + 1),
        },
        {
          title: '销售单号',
          minWidth: 116,
          key: 'saleOrderDetailOrderNo',
        },
        {
          title: '商品名称',
          minWidth: 116,
          key: 'saleRefundDetailGoodsName',
        },
        {
          title: '单价',
          minWidth: 116,
          render: (h, { row }) => h('span', row.saleRefundDetailRefundPrice),
        },
        {
          title: '销售数量',
          minWidth: 116,
          key: 'saleOrderDetailGoodsCount',
        },
        {
          title: '可退货数量',
          minWidth: 116,
          key: 'saleOrderDetailRefundableNum',
        },
        {
          title: '仓库/货位',
          minWidth: 116,
          render: (h, { row, index }) => {
            const inventoryArr = this.walkTree(row.refundableWarehouseLocationList);
            return h('lk-cascader', {
              on: {
                'on-change': (value, selectData) => {
                  this.changeInventory(index, value, selectData);
                },
              },
              props: {
                value: row.inventory,
                data: inventoryArr,
              },
            });
          }
          ,
        },
        {
          title: '退货数量',
          minWidth: 130,
          render: (h, { row, index }) => h('lk-input-number', {
            on: {
              'on-change': (e) => {
                const num = e;
                this.tableData[index].saleRefundDetailRefundNum = num;
                this.tableData[index].saleRefundDetailRefundAmount = Number(utils.toFixed(this.tableData[index].saleRefundDetailRefundPrice * num, 6, true), 10);
                this.generateSum();
              },
            },
            props: {
              value: row.saleRefundDetailRefundNum,
              placeholder: '数量',
              min: 0,
              precision: 2,
              max: 1000000000,
              'active-change': false,
            },
          }),
        },
        {
          title: '退货金额',
          minWidth: 130,
          key: 'saleRefundDetailRefundAmount',
        },
        {
          title: '退货原因',
          minWidth: 130,
          render: (h, { row, index }) => h('lk-input', {
            on: {
              'on-blur': (e) => {
                this.tableData[index].saleRefundDetailRefundReason = e.target.value;
              },
            },
            props: {
              value: row.saleRefundDetailRefundReason,
              placeholder: '原因',
            },
          }),
        },
      ],
      tableData: [],
    };
  },
  methods: {
    priceChange() {
      let sum = 0;
      for (let i = 0; i < this.refundList.length; i++) {
        if (this.refundList[i].amount && this.refundList[i].amount != undefined) {
          sum += this.refundList[i].amount * 1;
        }
      }
      for (let i = 0; i < this.refundData.length; i++) {
        if (this.refundData[i].refundAmount != undefined && this.refundData[i].refundAmount) {
          sum += this.refundData[i].refundAmount * 1;
        }
      }
      this.refundTotal = utils.toFixed(sum, 2, true);
    },
    deleteRefund(index) {
      this.refundList.splice(index, 1);
      this.priceChange();
    },
    addNew() {
      const temp = { proceedsTypeId: null, amount: null };
      if (this.refundList.length <= 0) {
        this.refundList = [{ proceedsTypeId: null, amount: null }];
      } else {
        this.refundList.push(temp);
      }
    },
    getData() {
      const params = {
        saleRefundId: this.saleRefundId,
      };
      afterSale.returnInfo(params).then((res) => {
        if (res.data.status === 200) {
          const data = res.data.data;
          this.saleRefund = data.saleRefund;
          let orderCode = '';
          data.saleRefundDetailVoList.forEach((vo) => {
            const result = {};
            orderCode = vo.saleOrderDetail.orderNo;
            utils.exchangeTable(vo, result);
            result.inventory = [result.saleRefundDetailWareHouseId, result.saleRefundDetailLocationId];
            result.saleRefundDetailRefundAmount = result.saleRefundDetailRefundAmount;
            result.saleRefundDetailRefundPrice = result.saleRefundDetailRefundPrice;
            this.tableData.push(result);
          });
          this.generateSum();
          this.getPayMethod(orderCode);
        }
      });
    },
    generateSum() {
      const sum = this.tableData.reduce((acc, current) => acc + current.saleRefundDetailRefundAmount * 1, 0);
      this.sumMoney = utils.toFixed(sum, 2, true);
    },
    changeInventory(index, value, selectData) {
      if (value.length <= 1) {
        this.$Message.error('请选择货位');
        return;
      }
      const [warehouse, locationItem] = selectData;
      this.tableData[index].saleRefundDetailWareHouseName = warehouse.warehouseName;
      this.tableData[index].saleRefundDetailWareHouseId = warehouse.warehouseId;
      this.tableData[index].saleRefundDetailLocationId = locationItem.locationId;
      this.tableData[index].saleRefundDetailLocationCode = locationItem.locationCode;
      this.tableData[index].inventory = value;
    },
    onAddRejectGoodsOk(selection) {
      this.ModalShow = false;
      let orderCode = '';
      selection.forEach((resItem) => {
        let isExist = false;
        orderCode = resItem.orderNo;
        this.tableData.forEach((tableItem) => {
          if (resItem.id === tableItem.saleOrderDetailId) {
            isExist = true;
          }
        });
        if (!isExist) {
          const res = {
            saleOrderDetailId: resItem.id,
            saleOrderDetailOrderNo: resItem.id,
            saleOrderDetailGoodsName: resItem.goodsName,
            saleRefundDetailRefundPrice: resItem.realPrice,
            saleOrderDetailGoodsCount: resItem.goodsCount,
            saleRefundDetailWareHouseId: '',
            saleRefundDetailWareHouseName: '',
            saleRefundDetailLocationId: '',
            saleRefundDetailLocationCode: '',
            saleRefundDetailRefundNum: '',
            saleRefundDetailRefundReason: '',
            saleOrderDetailRefundableNum: resItem.refundableNum,
            refundableWarehouseLocationList: resItem.refundableWarehouseLocationList,
            saleRefundDetailGoodsName: resItem.goodsName,
            saleRefundDetailRefundAmount: '',
          };
          this.tableData.push(res);
          this.generateSum();
        }
      });
      if (selection.length > 0) {
        this.getPayMethod(orderCode);
        this.getProceedsTypeList();
      }
    },
    getPayMethod(value) {
      afterSale.getPayMethod({ orderNo: value }).then((res) => {
        if (res.data.status == 200) {
          if (res.data.data.financeDepositInfos != undefined) {
            this.refundData = res.data.data.financeDepositInfos;
            this.refundData.forEach((item) => {
              if (!item.refundAmount) {
                item.refundAmount = null;
              }
            });
          }
          if (res.data.data.saleOrderProceeds != undefined) {
            this.refundList = res.data.data.saleOrderProceeds;
          } else {
            this.refundList = [{ proceedsTypeId: null, amount: null }];
          }
        } else {
          this.$Message.error(res.data.error);
        }
        this.loading = false;
        this.priceChange();
      });
    },
    resetTableData() {
      this.tableData = [];
      this.refundMethod = [];
      this.refundData = [];
    },
    showAddRejectGoods() {
      this.ModalShow = true;
    },
    onAddRejectGoodsModalCancel() {
      this.ModalShow = false;
    },
    onBtnClick: _.throttle(function a(name) {
      if (name === 'cancel') {
        this.onCancel();
      } else if (name === 'submit') {
        this.onSubmit();
      }
    }, 3000),
    onSubmit() {
      let data = {};
      let saleRefundDetailVoList = [];
      let saleRefund = {};
      let noGoods = false;
      let dataIsNotFull = false;
      let numNotValidate = false;

      saleRefundDetailVoList = this.tableData.map((item) => {
        if (!item.saleRefundDetailRefundNum
        || !item.saleRefundDetailRefundReason.trim()
        || !item.saleRefundDetailWareHouseId
        || !item.saleRefundDetailLocationId) {
          dataIsNotFull = true;
        }
        if ((Number.isNaN(Number(item.saleRefundDetailRefundNum)) || Number.isNaN(Number(item.saleRefundDetailRefundPrice)))) {
          numNotValidate = true;
        }
        return {

          saleOrderDetail: {
            id: item.saleOrderDetailId,
          },
          saleRefundDetail: {
            refundNum: item.saleRefundDetailRefundNum,
            refundReason: item.saleRefundDetailRefundReason,
            wareHouseId: item.saleRefundDetailWareHouseId,
            wareHouseName: item.saleRefundDetailWareHouseName,
            locationId: item.saleRefundDetailLocationId,
            locationCode: item.saleRefundDetailLocationCode,
            refundPrice: item.saleRefundDetailRefundPrice,
          },
        };
      });
      if (saleRefundDetailVoList.length <= 0) {
        noGoods = true;
      }
      saleRefund = {
        id: this.saleRefund.id,
        inspectRecord: this.saleRefund.inspectRecord,
        refundInspector: this.saleRefund.refundInspector,
      };

      if (!saleRefund.inspectRecord.trim() || !saleRefund.refundInspector.trim()) {
        dataIsNotFull = true;
      }

      data = {
        saleRefundDetailVoList, saleRefund,
      };

      const saleOrderProceeds = [];
      let hasProceeds = true;
      this.refundList.forEach((item) => {
        const methodData = {};
        methodData.proceedsTypeId = item.proceedsTypeId;
        if (item.proceedsTypeName == '' || item.proceedsTypeName == undefined) {
          if (this.refundData.length <= 0) { // 没有预收款，必须选一个退款方式
            hasProceeds = false;
          }
        }
        if (item.proceedsTypeName != '' && item.proceedsTypeName != undefined) {
          methodData.proceedsTypeName = item.proceedsTypeName;
          methodData.amount = item.amount;
          saleOrderProceeds.push(methodData);
        }
      });
      data.saleOrderProceeds = saleOrderProceeds;
      const financeDepositInfos = [];
      this.refundData.forEach((item) => {
        const refundData = {};
        refundData.financeDepositId = item.financeDepositId;
        refundData.financeDepositDetailId = item.financeDepositDetailId;
        refundData.refundAmount = item.refundAmount;
        financeDepositInfos.push(refundData);
      });
      data.financeDepositInfos = financeDepositInfos;
      if (this.sumMoney != this.refundTotal) {
        this.$Message.error('退款合计不等于退货金额合计，请检查后重新提交');
        return;
      }

      if (!hasProceeds) {
        this.$Message.error('请选择退款方式');
        return;
      }

      if (numNotValidate) {
        this.$Message.error('退货数量或者退货单价请输入正确的数字');
        return;
      }

      if (noGoods) {
        this.$Message.error('请选择商品');
        return;
      }
      if (dataIsNotFull) {
        this.$Message.error('请填写完整数据');
        return;
      }
      afterSale.updateReturn(data).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('保存成功');
          this.resetAll();
          this.jumpToList();
        } else {
          this.$Message.error(res.data.error);
        }
      });
    },
    resetAll() {
      this.resetTableData();
    },
    jumpToList() {
      this.$router.push({
        name: 'saleRefundList',
      });
    },
    onCancel() {
      this.resetAll();
      this.jumpToList();
    },
    walkTree(dataArr) {
      const res = [];
      dataArr.forEach((item) => {
        item.value = item.warehouseId;
        item.label = item.warehouseName;
        item.children = [];
        item.locationList.forEach((locationItem) => {
          locationItem.value = locationItem.locationId;
          locationItem.label = locationItem.locationCode;
          item.children.push(locationItem);
        });
        res.push(item);
      });
      return res;
    },
    getProceedsTypeList() {
      const tempParams = { status: 1 };
      if (this.tableData) {
        tempParams.goodsBaseIdList = this.tableData.map(item => item.goodsBaseId);
      }
      system.getStoreProceedsTypeList(tempParams).then((res) => {
        if (res.status === 200) {
          this.proceedsTypeList = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleProceedsTypeChange(item, index) {
      if (!item.proceedsTypeId || item.proceedsTypeId < 0) {
        this.clearIndexMethod(index);
        return;
      }
      const hasCount = this.refundList.filter(fItem => fItem.proceedsTypeId == item.proceedsTypeId).length;
      this.refundList[index].proceedsTypeName = this.proceedsTypeList.filter(fItem => fItem.proceedsTypeId == item.proceedsTypeId)[0].proceedsTypeName;
      if (hasCount > 1) {
        this.$Message.error('该退款方式已选中，请重新选择');
        this.clearIndexMethod(index);
      }
    },
    clearIndexMethod(index) {
      const tempList = utils.deepClone(this.refundList);
      this.refundList = [];
      tempList[index] = { proceedsTypeId: -1, amount: null, proceedsTypeName: '' };
      setTimeout(() => { // 设置延迟执行才可以，不知道什么原因
        this.refundList = tempList;
        this.priceChange();
      }, 1);
    },
  },
  computed: {
    selected() {
      return this.tableData.map(item => item.saleOrderDetailId);
    },
  },
  created() {
    this.getProceedsTypeList();
  },
  mounted() {
    const { id } = this.$route.params;
    this.saleRefundId = id;
    this.getData();
  },
};
</script>
<style lang="less" scoped>
.temp-img{
  height: 80px;
  width: 80px;
}
.other-card{
  margin-top: 30px;
}
.rejectTable{
  margin-bottom: 16px;
}
.addButton {
  font-weight: 500;
  color: #2d8cf0;;
}
.refundMethod {
  margin-bottom: 6px;
  display: flex !important;
}
.refundInput {
  display: inline !important;
}
.emptySpan {
  width: 93px;
}
</style>
